"use strict";
exports.isArrayLike = (function (x) { return x && typeof x.length === 'number'; });
//# sourceMappingURL=isArrayLike.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/rxjs/util/isArrayLike.js
// module id = 142
// module chunks = 0